// extracted by mini-css-extract-plugin
export var a = "structured-text-content-module--a--95a8e";
export var structuredText = "structured-text-content-module--structuredText--3ce36";